/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetReportTabs200ResponseItemsInner } from './GetReportTabs200ResponseItemsInner';
import {
    GetReportTabs200ResponseItemsInnerFromJSON,
    GetReportTabs200ResponseItemsInnerFromJSONTyped,
    GetReportTabs200ResponseItemsInnerToJSON,
    GetReportTabs200ResponseItemsInnerToJSONTyped,
} from './GetReportTabs200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetReportTabs200Response
 */
export interface GetReportTabs200Response {
    /**
     * 
     * @type {number}
     * @memberof GetReportTabs200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetReportTabs200Response
     */
    itemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof GetReportTabs200Response
     */
    total: number;
    /**
     * 
     * @type {Array<GetReportTabs200ResponseItemsInner>}
     * @memberof GetReportTabs200Response
     */
    items: Array<GetReportTabs200ResponseItemsInner>;
}

/**
 * Check if a given object implements the GetReportTabs200Response interface.
 */
export function instanceOfGetReportTabs200Response(value: object): value is GetReportTabs200Response {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetReportTabs200ResponseFromJSON(json: any): GetReportTabs200Response {
    return GetReportTabs200ResponseFromJSONTyped(json, false);
}

export function GetReportTabs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTabs200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
        'total': json['total'],
        'items': ((json['items'] as Array<any>).map(GetReportTabs200ResponseItemsInnerFromJSON)),
    };
}

export function GetReportTabs200ResponseToJSON(json: any): GetReportTabs200Response {
    return GetReportTabs200ResponseToJSONTyped(json, false);
}

export function GetReportTabs200ResponseToJSONTyped(value?: GetReportTabs200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
        'total': value['total'],
        'items': ((value['items'] as Array<any>).map(GetReportTabs200ResponseItemsInnerToJSON)),
    };
}

